import { withTheme } from '@mui/styles';
import styled from 'styled-components';

const TestimonialStyle = withTheme(styled.div`
  margin-top: 60px;

  .logo-item {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .carousel-container {
    padding-bottom: 30px;
    position: relative;

    .react-multi-carousel-track {
      padding: 0px 15px;
    }

    .next-button {
      position: absolute;
      right: 0px;
      width: 30px;
      height: 30px;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      background-color: white;
      border-radius: 50%;
      z-index: 1;
      color: ${(props: any) => props.theme.palette.primary.dark};
    }

    .previous-button {
      position: absolute;
      left: 0px;
      width: 30px;
      height: 30px;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      background-color: white;
      border-radius: 50%;
      z-index: 1;
      color: ${(props: any) => props.theme.palette.primary.dark};
    }

    .testimonial-card {
      .image {
        width: 175px;
        height: 175px;
        border-radius: 10px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        text-align: center;
        flex-direction: column;
        padding: 10px 5px;
        background-size: cover;

        .content {
          font-size: 16px;
          color: white;
          line-height: 1.19;
        }
        .user-info {
          font-size: 16px;
          font-weight: bold;
          line-height: 1.19;
          color: white;
        }
      }
    }

    .testimonial-custom-dot {
      border-radius: 10px;
      background-color: #cccccc;
      border: unset;
      width: 23px;
      height: 8px;
      cursor: pointer;
      margin-right: 3px;

      &.active {
        background-color: #16514d;
      }
    }
  }

  .client-logos-container {
    margin: 90px 0px;
  }

  .video-container {
    padding: 0px 20px;

    .testimonial-video {
      background: white;
      border-radius: 10px;

      video {
        border-radius: 10px;
        border: solid 1px #d3d3d3;
        background: white;
      }

      .vjs-big-play-button {
        line-height: 1.7;
        background-color: #174843;
        border-radius: 50%;
        border: unset;
        width: 50px;
        height: 50px;
        margin-left: -0.5em;
      }
    }
  }

  ${(props: any) => props.theme.breakpoints.down('lg')} {
    .client-logos-container {
      margin: 60px 0px;
    }

    .carousel-container {
      margin-top: 24px;

      .react-multi-carousel-track {
        padding: 0px;
      }

      .react-multi-carousel-item {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .testimonial-card {
        .image {
          width: ${(props: any) => props.width / 3 - 30}px;
          height: ${(props: any) => props.width / 3 - 30}px;
        }
      }

      .testimonial-dot-list {
        display: none;
      }
    }

    .video-container {
      padding: 0px;
    }
  }

  ${(props: any) => props.theme.breakpoints.down('sm')} {
    .client-logos-container {
      margin: 30px 0px;
    }

    .carousel-container {
      margin-top: 30px;

      .testimonial-card {
        .image {
          width: ${(props: any) => props.width * 0.65}px;
          height: ${(props: any) => props.width * 0.65}px;
        }
      }
    }
  }
`);

export default TestimonialStyle;
